
/**
 *
 * @class BatchCell
 *
 * base class for a simulation cell
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin
 * @date      February 2022
 *
 */

export class BatchCell {

  /** unique SWE cell id within it sbatch or result */
  public id: number            = 0;

  /** the SWE batch id, if monitoring a result, this is the batch the result spawned from */
  public batchId: number       = 0;

  /** the SWE result id (if we are monitoring) */
  public batchResultId: number = 0;

  /** errors reported by the cell */
  public errors: string[]      = [];

  /** name of the cell */
  public name:        string   = '';

  /** origin location of traffic being cloned */
  public trafficSrc:  string   = '';

  /** final placement of traffic blob */
  public trafficDst: string    = '';

  /** origin location of plant being cloned */
  public plantSrc:    string   = '';

  /** final placement of plant blob */
  public plantDst:    string   = '';

  /** is this cell enabled for simulation? */
  public enabled:    boolean   = true;

  /** any metadata for the cell */
  public meta: any             = {};

  /** last update time */
  public updated: Date         = null;

  /** the live progress received so far. */
  public progress: string[]    = [];

  /** the break down of pipeline work status for this cell */
  public steps: object         = {};

  /** the x ordering */
  public column: number        = 0;

  /** the y ordering */
  public row:    number        = 0;

  /** the tag of the column (traffic) */
  public colTag: number        = 0;

  /** the tag of the row (plant) */
  public rowTag: number        = 0;

  /** standard constructor */
  public constructor(init?: Partial<BatchCell>) {

    Object.assign(this, init);
  }
}
